/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Choice } from './Choice';
import {
    ChoiceFromJSON,
    ChoiceFromJSONTyped,
    ChoiceToJSON,
} from './Choice';
import type { ColumnViewSettings } from './ColumnViewSettings';
import {
    ColumnViewSettingsFromJSON,
    ColumnViewSettingsFromJSONTyped,
    ColumnViewSettingsToJSON,
} from './ColumnViewSettings';
import type { Constraint } from './Constraint';
import {
    ConstraintFromJSON,
    ConstraintFromJSONTyped,
    ConstraintToJSON,
} from './Constraint';
import type { Denotation } from './Denotation';
import {
    DenotationFromJSON,
    DenotationFromJSONTyped,
    DenotationToJSON,
} from './Denotation';
import type { IconRef } from './IconRef';
import {
    IconRefFromJSON,
    IconRefFromJSONTyped,
    IconRefToJSON,
} from './IconRef';
import type { TemplatePath } from './TemplatePath';
import {
    TemplatePathFromJSON,
    TemplatePathFromJSONTyped,
    TemplatePathToJSON,
} from './TemplatePath';
import type { TypeConstants } from './TypeConstants';
import {
    TypeConstantsFromJSON,
    TypeConstantsFromJSONTyped,
    TypeConstantsToJSON,
} from './TypeConstants';
import type { Unit } from './Unit';
import {
    UnitFromJSON,
    UnitFromJSONTyped,
    UnitToJSON,
} from './Unit';

/**
 * The single properties of this Group, in order
 * @export
 * @interface Info
 */
export interface Info {
    /**
     * 
     * @type {TypeConstants}
     * @memberof Info
     */
    type: TypeConstants;
    /**
     * 
     * @type {string}
     * @memberof Info
     */
    title?: string;
    /**
     * #RRGGBB (hexadecimal) format
     * @type {string}
     * @memberof Info
     */
    backgroundColor?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Info
     */
    visible: boolean;
    /**
     * 
     * @type {string}
     * @memberof Info
     */
    label: string;
    /**
     * 
     * @type {Denotation}
     * @memberof Info
     */
    denotation?: Denotation;
    /**
     * 
     * @type {IconRef}
     * @memberof Info
     */
    icon?: IconRef;
    /**
     * 
     * @type {string}
     * @memberof Info
     */
    id: string;
    /**
     * 
     * @type {Choice}
     * @memberof Info
     */
    choice?: Choice;
    /**
     * 
     * @type {ColumnViewSettings}
     * @memberof Info
     */
    columnViewSettings?: ColumnViewSettings;
    /**
     * 
     * @type {Constraint}
     * @memberof Info
     */
    constraint?: Constraint;
    /**
     * ID of the currently selected unit, one of the units returned by getUnits()
     * @type {string}
     * @memberof Info
     */
    currentUnitId?: string;
    /**
     * Choice of available units (for tables)
     * @type {Array<Unit>}
     * @memberof Info
     */
    units?: Array<Unit>;
    /**
     * Whether this property is auto calculated.
     * @type {boolean}
     * @memberof Info
     */
    autoCalculated?: boolean;
    /**
     * Whether the property is editable (edit case only).
     * @type {boolean}
     * @memberof Info
     */
    editable?: boolean;
    /**
     * If true, this property is not a single value, but a list of properties with the given Property.Info
     * @type {boolean}
     * @memberof Info
     */
    list?: boolean;
    /**
     * Whether the property is sortable (tables only).
     * @type {boolean}
     * @memberof Info
     */
    sortable?: boolean;
    /**
     * Whether this is a trigger property or not, true for conditional visibility or for attached ajax support
     * @type {boolean}
     * @memberof Info
     */
    triggerProperty?: boolean;
    /**
     * If true, the text should be rendered as multiline, such as TextArea.
     * @type {boolean}
     * @memberof Info
     */
    isMultiLine?: boolean;
    /**
     * List to be used by the spreadsheet editor in the frontend to get the different templates
     * @type {Array<TemplatePath>}
     * @memberof Info
     */
    defaultTemplatePaths?: Array<TemplatePath>;
    /**
     * If true, the spreadsheet editor will be available in the frontend.
     * @type {boolean}
     * @memberof Info
     */
    spreadsheetEnabled?: boolean;
    /**
     * If true, the value from an edit page or wizard will be rendered as on a Show page 
     * @type {boolean}
     * @memberof Info
     */
    useShowView?: boolean;
}

/**
 * Check if a given object implements the Info interface.
 */
export function instanceOfInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "visible" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function InfoFromJSON(json: any): Info {
    return InfoFromJSONTyped(json, false);
}

export function InfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): Info {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': TypeConstantsFromJSON(json['type']),
        'title': !exists(json, 'title') ? undefined : json['title'],
        'backgroundColor': !exists(json, 'backgroundColor') ? undefined : json['backgroundColor'],
        'visible': json['visible'],
        'label': json['label'],
        'denotation': !exists(json, 'denotation') ? undefined : DenotationFromJSON(json['denotation']),
        'icon': !exists(json, 'icon') ? undefined : IconRefFromJSON(json['icon']),
        'id': json['id'],
        'choice': !exists(json, 'choice') ? undefined : ChoiceFromJSON(json['choice']),
        'columnViewSettings': !exists(json, 'columnViewSettings') ? undefined : ColumnViewSettingsFromJSON(json['columnViewSettings']),
        'constraint': !exists(json, 'constraint') ? undefined : ConstraintFromJSON(json['constraint']),
        'currentUnitId': !exists(json, 'currentUnitId') ? undefined : json['currentUnitId'],
        'units': !exists(json, 'units') ? undefined : ((json['units'] as Array<any>).map(UnitFromJSON)),
        'autoCalculated': !exists(json, 'autoCalculated') ? undefined : json['autoCalculated'],
        'editable': !exists(json, 'editable') ? undefined : json['editable'],
        'list': !exists(json, 'list') ? undefined : json['list'],
        'sortable': !exists(json, 'sortable') ? undefined : json['sortable'],
        'triggerProperty': !exists(json, 'triggerProperty') ? undefined : json['triggerProperty'],
        'isMultiLine': !exists(json, 'isMultiLine') ? undefined : json['isMultiLine'],
        'defaultTemplatePaths': !exists(json, 'defaultTemplatePaths') ? undefined : ((json['defaultTemplatePaths'] as Array<any>).map(TemplatePathFromJSON)),
        'spreadsheetEnabled': !exists(json, 'spreadsheetEnabled') ? undefined : json['spreadsheetEnabled'],
        'useShowView': !exists(json, 'useShowView') ? undefined : json['useShowView'],
    };
}

export function InfoToJSON(value?: Info | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': TypeConstantsToJSON(value.type),
        'title': value.title,
        'backgroundColor': value.backgroundColor,
        'visible': value.visible,
        'label': value.label,
        'denotation': DenotationToJSON(value.denotation),
        'icon': IconRefToJSON(value.icon),
        'id': value.id,
        'choice': ChoiceToJSON(value.choice),
        'columnViewSettings': ColumnViewSettingsToJSON(value.columnViewSettings),
        'constraint': ConstraintToJSON(value.constraint),
        'currentUnitId': value.currentUnitId,
        'units': value.units === undefined ? undefined : ((value.units as Array<any>).map(UnitToJSON)),
        'autoCalculated': value.autoCalculated,
        'editable': value.editable,
        'list': value.list,
        'sortable': value.sortable,
        'triggerProperty': value.triggerProperty,
        'isMultiLine': value.isMultiLine,
        'defaultTemplatePaths': value.defaultTemplatePaths === undefined ? undefined : ((value.defaultTemplatePaths as Array<any>).map(TemplatePathToJSON)),
        'spreadsheetEnabled': value.spreadsheetEnabled,
        'useShowView': value.useShowView,
    };
}

